import { enableProdMode, APP_ID, provideAppInitializer, inject, importProvidersFrom, ApplicationConfig } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';
import { AppConfigService } from './_shared/_services';
import { AppRoutingModule } from './app-routing.module';
import { GraphQLModule } from './graphql.module';
import { ShellModule } from './shell/shell.module';

const siteKey = '6Lfe_R0hAAAAAHATA3UX0BjgkTILMG_LamvZzb4_';

if (environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(AppRoutingModule, MatFormFieldModule, MatInputModule, MatExpansionModule, NgxMaskDirective, NgxMaskPipe, NgxSpinnerModule, ReactiveFormsModule, ShellModule, GraphQLModule, FontAwesomeModule, RecaptchaV3Module),
    {
      provide: APP_ID,
      useValue: 'serverApp'
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        floatLabel: 'always',
        appearance: 'outline'
      }
    },
    provideAppInitializer(async () => {
      const initializerFn = ((config: AppConfigService) => async () => config.load())(inject(AppConfigService));

      return initializerFn();
    }),
    {
      provide: RECAPTCHA_V3_SITE_KEY, useValue: siteKey
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      const auth = setContext((operation, context) => {
        return {
          headers: {
            'x-shopify-storefront-access-token': `${environment.shopifyaccesstoken}`
          }
        };
      });

      return {
        link: auth.concat(httpLink.create({ uri: environment.graphQlUrl })),
        cache: new InMemoryCache()
      };
    }),
    provideClientHydration(withEventReplay())
  ]
};
